module.exports = __webpack_public_path__ + "static/logo-f466a9d93c35c1bce010a74d5ba03732.svg";